import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "mask",
    standalone: false
})
export class NumberMaskPipe implements PipeTransform {
  transform(number: string): string {
    if (!number) {
      return "";
    }

    const visibleLastDigits = 3;
    const visibleFirstDigits = 2;
    let maskedSection = number.slice(visibleFirstDigits, -visibleLastDigits);
    let visibleSection = number.slice(-visibleLastDigits);
    let visibleFirstSection = number.slice(0, visibleFirstDigits);
    return (
      visibleFirstSection + maskedSection.replace(/./g, "X") + visibleSection
    );
  }
}

@Pipe({
    name: "emailmask",
    standalone: false
})
export class EmailMaskPipe implements PipeTransform {
  transform(email: string): string {
    if (!email) {
      return "";
    }
    const atIndex = email.indexOf("@");
    if (atIndex <= 0) {
      return email;
    }
    const localPart = email.substring(0, atIndex);
    const domainPart = email.substring(atIndex);
    const visible = 3;
    if (localPart.length <= visible) {
      return localPart.replace(/./g, "X") + domainPart;
    }
    const maskedLocal =
      localPart.substring(0, visible) +
      localPart.substring(visible).replace(/./g, "X");
    return maskedLocal + domainPart;
  }
}
